/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_HeadingInputs */

const tr_mesafeli_s11_heading = /** @type {(inputs: Mesafeli_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Alt Yüklenici (Sub-Processor) Listesi`)
};

const en_mesafeli_s11_heading = /** @type {(inputs: Mesafeli_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Sub-Processor List`)
};

const de_mesafeli_s11_heading = /** @type {(inputs: Mesafeli_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Liste der Unterauftragnehmer (Sub-Processor)`)
};

const ru_mesafeli_s11_heading = /** @type {(inputs: Mesafeli_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Список субобработчиков (Sub-Processor)`)
};

/**
* | output |
* | --- |
* | "11. Sub-Processor List" |
*
* @param {Mesafeli_S11_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_heading = /** @type {((inputs?: Mesafeli_S11_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_heading(inputs)
	if (locale === "de") return de_mesafeli_s11_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s11_heading(inputs)
	return tr_mesafeli_s11_heading(inputs)
});